var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from 'styled-components';
import { grayBorder } from './CMSTouchPanel/colors';
var WindowTitle = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: grid;\n  height: 16px;\n  width: 100%;\n  font-size: 13px;\n  justify-content: center;\n  text-transform: uppercase;\n  background: rgba(16, 19, 29, 1);\n  ", "\n"], ["\n  display: grid;\n  height: 16px;\n  width: 100%;\n  font-size: 13px;\n  justify-content: center;\n  text-transform: uppercase;\n  background: rgba(16, 19, 29, 1);\n  ", "\n"])), grayBorder);
export default WindowTitle;
var templateObject_1;
//# sourceMappingURL=WindowTitle.js.map